<template>
  <div class="event-wrap">
    <div class="page-header">
      <el-select
        popper-class="BI-select BI-select-product report_select"
        class="all-select"
        v-model="filterData.advertiserId"
        filterable
        multiple
        collapse-tags
        :filter-method="filterCount"
        placeholder="请选择广告账户"
        @change="changeAdvertiserId"
      >
        <el-checkbox v-model="checked" @change="selectAll($event, 'check')">全选</el-checkbox>
        <el-option
          v-for="item of countList"
          :key="item.advertiserId"
          :value="item.advertiserId"
          :label="item.company + '-' + item.advertiserName"
        ></el-option>
      </el-select>
      <el-select class="select-item" v-model="filterData.eventType" @change="getEventsList">
        <el-option label="全部事件" :value="null"> </el-option>
        <el-option label="激活" value="active"> </el-option>
        <el-option label="关键行为" value="game_addiction"> </el-option>
      </el-select>
      <el-button class="header-btn" @click="refreshData(false)" style="margin-left: auto">
        <i class="el-icon-refresh-left"></i>
        同步数据
      </el-button>
      <!-- <el-button class="header-btn" @click="addEvent" type="primary">添加事件</el-button> -->
    </div>
    <div class="page-content">
      <div class="left">
        <div class="left-search">
          <el-select class="select-item" v-model="platType" @change="changePlatType">
            <el-option label="全部类型" :value="null"> </el-option>
            <el-option label="Android" value="ANDROID"> </el-option>
            <el-option label="IOS" value="IOS"> </el-option>
          </el-select>
          <el-input class="select-item" style="margin-left: 16px" v-model="searchKey" @change="changeAssetName" placeholder="搜索名称" />
        </div>
        <div class="product-list">
          <div
            @click="changeProduct(item)"
            v-for="item in productList"
            :key="item.assetId"
            class="product-list-item"
            :class="{ 'selected-item': item.assetId === selectedData.assetId }"
          >
            <svg-icon v-if="item.appType === 'ANDROID'" iconClass="android" class="android-icon" style="fill: #5fd21c"></svg-icon>
            <svg-icon v-else iconClass="apple" class="android-icon"></svg-icon>
            <div class="detail">
              <div class="name">{{ item.assetName }}</div>
              <div class="id">{{ item.assetId }}</div>
            </div>
          </div>
        </div>
        <!-- <el-button class="add-btn">添加资产</el-button> -->
      </div>
      <div class="right" v-if="productList.length > 0">
        <div class="title">{{ selectedData.assetName }}</div>
        <div class="id">{{ selectedData.assetId }}</div>
        <div class="table-container">
          <el-tabs v-model="activeName" type="card" style="margin-top: 28px">
            <el-tab-pane label="事件列表" name="first">
              <el-table :data="eventTableData" :max-height="tableHeight" style="width: 100%" ref="table">
                <el-table-column prop="eventCnName" label="事件名称" width="300px"> </el-table-column>
                <el-table-column prop="trackTypes" label="回传方式" width="300px">
                  <template> API回传</template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="200px"> </el-table-column>
                <el-table-column prop="advertiserId" label="广告账户"> </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="监测链接" name="second">
              <div style="display: flex; margin-bottom: 12px; justify-content: space-between">
                <el-input placeholder="搜索监测链接名称" v-model="trackUrlGroupName" @change="getLinkList" style="width: 200px"></el-input>
                <el-button @click="addLink">添加监测链接</el-button>
              </div>
              <el-table :data="linkTableData" :max-height="tableHeight - 45" style="width: 100%">
                <el-table-column v-for="item in columns" :key="item.prop" :prop="item.prop" :label="item.label">
                  <template slot-scope="scope">
                    <el-popover
                      placement="top-start"
                      title=""
                      width="400"
                      trigger="hover"
                      :content="scope.row[item.prop]"
                      v-if="scope.row[item.prop] && item.prop !== 'track_url_group_name'"
                    >
                      <div slot="reference" class="url-content">{{ scope.row[item.prop] }}</div>
                    </el-popover>
                    <div v-else>{{ scope.row[item.prop] || "--" }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="account" label="操作">
                  <template slot-scope="scope">
                    <el-button type="text" size="small" slot="reference" @click="editLink(scope.row)">编辑</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <div class="right" v-else>
        <el-empty description="暂无数据"></el-empty>
      </div>
    </div>

    <dialog-form ref="dialogFormRef" @successCallBack="successCallBack"></dialog-form>
  </div>
</template>

<script>
import { getAdCount } from "@/api/property.js";
import SvgIcon from "@/components/SvgIcon.vue";
import DialogForm from "./dialogForm";
import { getAllAssets_tt, refreshAssets_tt, getEvents_tt, getTruckUrl_tt } from "@/api/platReport";

const columns = [
  { prop: "track_url_group_name", label: "监测链接名称" },
  { prop: "track_url", label: "展示" },
  { prop: "action_track_url", label: "有效触点" },
  { prop: "video_play_track_url", label: "视频播放" },
  { prop: "video_play_done_track_url", label: "视频播完" },
  { prop: "video_play_effective_track_url", label: "视频有效播放" },
];
export default {
  components: {
    SvgIcon,
    DialogForm,
  },

  data() {
    return {
      columns,
      countList: [],
      copyCountList: [],
      checked: false,
      filterData: {
        advertiserId: -1,
        eventType: null,
      },
      trackUrlGroupName: "",
      platType: null,
      searchKey: "",
      productList: [],
      selectedData: {},
      eventTableData: [],
      linkTableData: [],
      activeName: "first",
      tableHeight: window.innerHeight - 348,
      modalType: "add",
    };
  },

  computed: {},

  watch: {},

  mounted() {
    this.initSelect();
    this.getAssetsList();
  },

  methods: {
    initSelect() {
      getAdCount().then((res) => {
        if (res.code === "0000") {
          this.countList = res.advertiseInfos;
          this.copyCountList = JSON.parse(JSON.stringify(res.advertiseInfos));
        }
      });
    },
    filterCount(value) {
      if (value) {
        this.countList = this.copyCountList.filter((item) => {
          return (
            (item.advertiserId + "").toLowerCase().indexOf(value.toLowerCase()) >= 0 ||
            (item.advertiserName + "").toLowerCase().indexOf(value.toLowerCase()) >= 0 ||
            (item.company + "").toLowerCase().indexOf(value.toLowerCase()) >= 0
          );
        });
      } else {
        this.countList = this.copyCountList;
      }
    },
    selectAll(event, value) {
      if (event) {
        let arr = [];
        this.countList.map((v) => arr.push(v.advertiserId));
        this.filterData.advertiserId = arr;
      } else {
        value == "check" ? (this.filterData.advertiserId = []) : null;
      }
    },
    refreshData(flag) {
      refreshAssets_tt({
        advertiserId: this.filterData.advertiserId.join(",") || null,
      }).then((res) => {
        if (res.code === "0000") {
          this.$message({
            message: "同步成功",
            type: "success",
          });
          this.getAssetsList(flag);
        }
      });
      this.getAssetsList(flag);
    },
    changeProduct(item) {
      this.selectedData = item;
      this.trackUrlGroupName = "";
      this.getEventsList();
      this.getLinkList();
    },
    getEventsList() {
      getEvents_tt({
        assetId: this.selectedData.assetId,
        eventType: this.filterData.eventType,
      }).then((res) => {
        this.eventTableData = res.data;
      });
    },
    getLinkList() {
      getTruckUrl_tt({
        advertiserId: this.selectedData.advertiserId,
        assetId: this.selectedData.assetId,
        downloadUrl: this.selectedData.downloadUrl,
        trackUrlGroupName: this.trackUrlGroupName || null,
      }).then((res) => {
        this.linkTableData = res.track_url_groups;
      });
    },
    successCallBack() {
      this.refreshData(true);
      setTimeout(() => {
        this.getLinkList();
      }, 500);
    },
    getAssetsList(flag) {
      getAllAssets_tt({
        advertiserId: this.filterData.advertiserId.join(",") || null,
        osType: this.platType,
        assetName: this.searchKey,
      }).then((res) => {
        this.productList = res.data;
        if (!flag) {
          this.selectedData = res.data[0] || {};
        }
        if (res.data.length > 0) {
          this.getEventsList();
          this.getLinkList();
        }
      });
    },
    changeAdvertiserId() {
      this.getAssetsList();
    },
    changeAssetName() {
      this.getAssetsList();
    },
    changePlatType() {
      this.getAssetsList();
    },
    addLink() {
      this.$refs.dialogFormRef.showModal("add", this.selectedData);
    },
    editLink(data) {
      this.$refs.dialogFormRef.showModal("edit", this.selectedData, data);
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
.event-wrap {
  padding: 16px;
  height: calc(100vh - 72px);
  overflow: hidden;
  .page-header {
    display: flex;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding: 16px 24px;
    .select-item {
      margin-left: 24px;
    }
    .header-btn {
      padding: 5px 22px;
    }
  }
  .page-content {
    margin-top: 16px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    display: flex;
    height: calc(100% - 120px);
    .left {
      width: 300px;
      height: 100%;
      border-right: 1px solid #f0f0f0;
      .left-search {
        display: flex;
        padding: 16px 24px;
        .select-item {
          width: 188px;
        }
      }
      .product-list {
        height: calc(100% - 72px);
        overflow: overlay;
        .product-list-item {
          display: flex;
          padding: 12px 20px;
          cursor: pointer;
          .android-icon {
            width: 48px;
            font-size: 39px;
          }
          .detail {
            margin-left: 12px;
            .name {
              font-size: 15px;
              font-weight: bold;
              max-width: 214px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .id {
              font-size: 13px;
              margin-top: 4px;
              color: #777;
            }
          }
        }
        .selected-item {
          background: #f5f6f6;
        }
      }
      .add-btn {
        width: 200px;
        text-align: center;
        margin: 10px 50px;
      }
    }
    .right {
      padding: 16px 24px;
      flex: 1;
      position: relative;
      .title {
        font-weight: 600;
        font-size: 20px;
      }
      .id {
        font-size: 14px;
        color: #777;
        margin-top: 5px;
      }
      .table-container {
        position: absolute;
        width: calc(100% - 48px);
      }
      .url-content {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
    }
  }
}
.el-checkbox {
  width: 95%;
  text-align: right;
}
</style>
